module.exports = __webpack_public_path__ + "img/13.a8f43f9e.jpg";